export interface RegisterModel {
  userName: string;
  password: string;
  confirmPassword: string;
  email: string;
  firstname: string;
  lastname: string;
}
